import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "w-full border rounded-lg border-neutral-100" }
const _hoisted_5 = { class: "relative overflow-auto" }
const _hoisted_6 = { class: "absolute left-0 top-0 h-full whitespace-nowrap position w-[181px] shadow-[2px_0_16px_0px_rgb(0,0,0,0.08)]" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-[26px] bg-primary-100 text-sm font-semibold relative" }, "Settings", -1)
const _hoisted_8 = { class: "pl-[181px] min-h-[500px]" }
const _hoisted_9 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-[18px] text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = {
  key: 0,
  class: "flex mb-2 w-max"
}
const _hoisted_12 = { class: "flex items-center justify-center mx-auto w-max" }

import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import SideTab from "@/views/settings/Components/SideTab.vue";
import DataTable from '@/components/partials/DataTable.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import ImportButton from '@/components/buttons/ImportButton.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import http from "@/axios";
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import Storage from "@/helpers/storage";
import SuccessModal from "@/components/modals/SuccessModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataManifestIndex',
  setup(__props) {

const storage = new Storage();
const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Manifest' },
];
const showSuccess = ref(false);
const message = ref(null);
const items = ref([
    {
        name: "Intervention",
        manifest_url: "manifest/intervention",
        import_url: "/manifest/intervention",
        file: null,
        hasFile: false,
        hasSelector: true,
        intervention_id: null,
        intervention_type: null,
    },
    {
        name: "Patients",
        manifest_url: "manifest/patient",
        import_url: "/manifest/patient",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Cases",
        manifest_url: "manifest/cases",
        import_url: "/manifest/cases",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case: Other Information > Guardians",
        manifest_url: "manifest/case_guardians",
        import_url: "/manifest/case_guardians",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case: Other Information > Informants",
        manifest_url: "manifest/case_informants",
        import_url: "/manifest/case_informants",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case: Other Information > Patient Address",
        manifest_url: "manifest/case_patient_address",
        import_url: "/manifest/case_patient_address",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Perpetrators",
        manifest_url: "manifest/perpetrator",
        import_url: "/manifest/perpetrator",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Link Perpetrators to Cases",
        manifest_url: "manifest/case_perpetrator",
        import_url: "/manifest/case_perpetrator",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case Intake",
        manifest_url: "manifest/case_intake",
        import_url: "/manifest/case_intake",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case Safety Assessment",
        manifest_url: "manifest/case_safety_assessment",
        import_url: "/manifest/case_safety_assessment",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Case Conference",
        manifest_url: "manifest/case_conference",
        import_url: "/manifest/case_conference",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Office",
        manifest_url: "manifest/office",
        import_url: "/manifest/office",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
    {
        name: "Personnel",
        manifest_url: "manifest/personnel",
        import_url: "/manifest/personnel",
        file: null,
        hasFile: false,
        hasSelector: false,
    },
]);
const interventionOptions = ref([]);
const interventionTypeOptions = ref([]);

const downloadManifest = async (item: any) => {
    const user = JSON.parse(storage.get('user'));
    return window.open(`${process.env.VUE_APP_API_URL}${item.manifest_url}?intervention=${item.intervention_id}&intervention_type=${item.intervention_type}&office_id=${user.office_id}&role_id=${user.role_id}`, "_blank");
}

const importManifest = async (item: any) => {
    const formData = new FormData();
    formData.append('file', item.file);
    if (item.intervention_id) {
        formData.append('intervention', item.intervention_id);
    }

    if (item.intervention_type) {
        formData.append('intervention_type', item.intervention_type);
    }

    const user = JSON.parse(storage.get('user'));
    if (user) {
        formData.append('office_id', user.office_id);
        formData.append('role_id', user.office_id);
    }
    
    const response = await http.post(item.import_url, formData);
    message.value = response?.data?.message || '';
    showSuccess.value = true;
}

const fileChanged = (event: any, item: any) => {
    showSuccess.value = false;
    message.value = null;
    item.file = event.target.files[0];
    item.hasFile = item.file ? true : false;
}

const loadData = async () => {
    const response = await http.get('/manifest/load-intervention');
    if (response.status === 200) {
        interventionOptions.value = response?.data?.items || [];
    }
}

const loadInterventionType = async (value: any) => {
    const response = await http.post('/manifest/load-intervention-type', { intervention: value});
    if (response.status === 200) {
        interventionTypeOptions.value = response.data;
    }
}

onMounted(() => loadData());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Data Manifest",
            description: "Import data"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(SideTab, { barangaySelected: "" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createVNode(DataTable, {
                    headers: headers,
                    "no-action": false,
                    hasSearch: false,
                    count: items.value.length,
                    searchPlaceholder: "Search region",
                    tableClass: "header-frm-table",
                    dataTableClass: "border-0"
                  }, {
                    body: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                        return (_openBlock(), _createElementBlock("tr", { key: item }, [
                          _createElementVNode("td", _hoisted_9, _toDisplayString(item.name), 1),
                          _createElementVNode("td", _hoisted_10, [
                            (item.hasSelector)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(SelectOptions, {
                                    options: interventionOptions.value,
                                    label: "Select Intervention",
                                    id: "selector-id",
                                    class: "w-[250px]",
                                    name: "selector-name",
                                    placeholder: "Select Intervention",
                                    modelValue: item.intervention_id,
                                    "onUpdate:modelValue": [
                                      ($event: any) => ((item.intervention_id) = $event),
                                      _cache[0] || (_cache[0] = (value) => loadInterventionType(value))
                                    ]
                                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                  (interventionTypeOptions.value.length > 0)
                                    ? (_openBlock(), _createBlock(MultiSelect, {
                                        key: 0,
                                        class: "ml-5 w-[400px]",
                                        options: interventionTypeOptions.value,
                                        id: "intervention",
                                        name: "intervention type",
                                        label: "Select Intervention Type",
                                        placeholder: "Select..",
                                        searchable: "",
                                        required: "",
                                        modelValue: item.intervention_type,
                                        "onUpdate:modelValue": ($event: any) => ((item.intervention_type) = $event)
                                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(ExportButton, {
                                class: "mr-5",
                                title: "Download Manifest",
                                onClick: ($event: any) => (downloadManifest(item))
                              }, null, 8, ["onClick"]),
                              (item.hasFile)
                                ? (_openBlock(), _createBlock(ImportButton, {
                                    key: 0,
                                    onClick: ($event: any) => (importManifest(item))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(TextInput, {
                                type: "file",
                                onChange: ($event: any) => (fileChanged($event, item))
                              }, null, 8, ["onChange"])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["count"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccess.value,
        "action-text": "Close",
        title: "Import Processing",
        content: message.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSuccess.value = false))
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }))
}
}

})